// Vimeo popup for .ck-video-popup links.
// Reuses the Magnific Popup setup from the Dutch Boosting Group site (src/default/js/app.js);
// base CSS is imported in scss/styles.scss, overrides live in scss/common/_video-overview.scss.
import $ from 'jquery'
import 'magnific-popup'

const PLAYER_PARAMS = 'autoplay=1&color=eb5728&title=0&byline=0&portrait=0'

// Supports https://vimeo.com/123, https://vimeo.com/123/abcdef (unlisted hash) and player.vimeo.com/video/123
const VIMEO_URL = /vimeo\.com\/(?:video\/)?(\d+)(?:\/([a-z0-9]+))?/i

export const vimeoEmbedPath = (url) => {
    const match = VIMEO_URL.exec(url)

    if (!match) {
        return null
    }

    const [, id, hash] = match

    return `${id}?${hash ? `h=${hash}&` : ''}${PLAYER_PARAMS}`
}

export const videoPopup = {
    init() {
        const $links = $('.ck-video-popup')

        if (!$links.length) {
            return
        }

        $links.magnificPopup({
            type: 'iframe',
            mainClass: 'mfp-fade',
            removalDelay: 160,
            preloader: false,
            iframe: {
                patterns: {
                    vimeo: {
                        index: 'vimeo.com/',
                        // ponytail: %id% carries the query string too, so one pattern covers plain and unlisted links
                        id: vimeoEmbedPath,
                        src: 'https://player.vimeo.com/video/%id%',
                    },
                },
            },
        })
    },
}
